import React from 'react';
import { useState } from 'react';

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

function LoadReportTbl(props) {
    const [teacherFiltered, setTeacherFiltered] = useState("");
    const [sortOrder, setSortOrder] = useState(null);
    const lstTchSummary = props.lstTchSummary || [];

    const getTotalLoad = (lstDayCount) => {
        return lstDayCount.reduce((sum, count) => sum + count, 0);
    };

    const toggleSort = () => {
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const filteredList = lstTchSummary.filter((obj) =>
        obj.tch.toLowerCase().includes(teacherFiltered.trim().toLowerCase())
    );

    if (sortOrder) {
        filteredList.sort((a, b) => {
            const totalA = getTotalLoad(a.lstDayCount);
            const totalB = getTotalLoad(b.lstDayCount);
            return sortOrder === "asc" ? totalA - totalB : totalB - totalA;
        });
    }

    return (
        <div>
            <table className="tableLayout1 tchsummary" style={{ width: 700 }}>
                <thead>
                    <tr>
                        <th style={{ width: 25 + '%' }}>
                            <input
                                type="text"
                                className="form-control inp-search"
                                value={teacherFiltered}
                                onChange={(e) => setTeacherFiltered(e.target.value)}
                                placeholder="Teacher" />
                        </th>
                        <th style={{ width: 15 + '%' }}>Class/Sec</th>
                        {DAYS.map((d) => (
                            <th key={d} className="text-center" style={{ width: 7 + '%' }}>{d}</th>
                        ))}
                        <th className="text-center" style={{ width: 11 + '%' }}>
                            {"Total Load "}
                            {sortOrder !== "asc" ? (
                                <span
                                    title="Sort Ascending"
                                    className="glyphicon glyphicon-triangle-top icon-btn"
                                    style={{ cursor: 'pointer', color: sortOrder === "desc" ? "black" : "white" }}
                                    onClick={() => setSortOrder("asc")}
                                ></span>
                            ) : (
                                <span
                                    title="Sort Descending"
                                    className="glyphicon glyphicon-triangle-bottom icon-btn"
                                    style={{ cursor: 'pointer', color: "black" }}
                                    onClick={() => setSortOrder("desc")}
                                ></span>

                               
                            )}
                        </th>
                    </tr>
                </thead>
            </table>
            <div className="tchsummaryTableDiv" style={{ height: '75vh', overflowY: 'scroll', border: '1px solid #ccc' }}>
                <table id="loadReportTable" className="tableLayout">
                    <tbody>
                        {filteredList.map((obj) => (
                            <tr key={obj.tchId}>
                                <td style={{ width: 25 + '%', fontWeight: 'bold' }}>{obj.tch}</td>
                                <td style={{ width: 15 + '%' }}>{obj.clsSec}</td>
                                {DAYS.map((d, i) => (
                                    <td key={d} className="text-center" style={{ width: 7 + '%' }}>
                                        {obj.lstDayCount[i]}
                                    </td>
                                ))}
                                <td className="text-center" style={{ width: 11 + '%', fontWeight: 'bold' }}>
                                    {getTotalLoad(obj.lstDayCount)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default LoadReportTbl
